import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import user from './modules/user/user'
import auth from './modules/auth/auth'
import wallet from './modules/wallet/wallet'
import university from './modules/university/university'
import countries from './modules/countries'
import city from './modules/city'
import cart from './modules/cart/cart'
import orders from './modules/orders/orders'
import evaluationOrder from './modules/evaluationOrder'
import checkout from './modules/checkout/checkout'
import subscriptions from './modules/subscriptions'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isUnderMobile: false,
    isXLScreen: false,
    programOrder: new Date(),
    filterPrice: [],
    filterTime: 'timeAll',
    filterOrder: 'Todos',
    search: '',
    spinner: false,
    supportTracker: false,
    openBurguerMenu: false,
    mealIngredients: [],
    selectedMeal: [],
    IngredientToDestroy: [],
    newPlate: [],
    mealPayload: [],
    ingredientsPayload: [],
    selectedIngredient: [],
    selected_menu_id: null,
  },
  mutations: {
    SPINNER (state, bool) {
      state.spinner = bool
    },
    SUPPORT_TRACKER (state, data) {
      state.supportTracker = data
    },
    // tamaño de la pantalla
    IS_UNDER_MOBILE (state: any, data: any) {
      state.isUnderMobile = data
    },
    // Filtros
    FILTER_ORDER (state, data) {
      state.filterOrder = data
    },
    FILTER_TIME (state, data) {
      state.filterTime = data
    },
    FILTER_PRICE (state, data) {
      state.filterPrice = data
    },
    // campo de busqueda
    SEARCH (state, data) {
      state.search = data
    },
    IS_XL_SCREEN (state, data) {
      state.isXLScreen = data
    },
    OPEN_BURGUER_MENU (state, data) {
      state.openBurguerMenu = data;
    },
    SET_MEAL_INGREDIENTS (state, data) {
      state.mealIngredients = data;
    },
    SET_CURRENT_MEAL (state, data) {
      state.selectedMeal = data;
      state.IngredientToDestroy = data.items[0];
    },

    SET_INGREDIENT_TO_DESTROY (state, data) {
      state.IngredientToDestroy = state.mealIngredients[data];
      console.log(state.IngredientToDestroy)
    },

    SET_NEW_PLATE (state, data) {
      state.newPlate = data;
      console.log('newPlate', state.newPlate);
    },
    SET_SELECTED_INGREDIENT(state, data) {
      state.selectedIngredient = data;
    },
    SET_SELECTED_MENU_ID(state, data) {
      state.selected_menu_id = data;
    }
  },
  getters: {
    getSpinner (state: any) {
      return state.spinner
    },
    // tamaño de la pantalla
    getIsUnderMobile (state: any) {
      return state.isUnderMobile
    },
    // programar orden
    getProgramOrder (state: any) {
      return state.programOrder
    },
    // Filtros
    getFilterPrice (store) {
      return store.filterPrice
    },
    getFilterOrder (store) {
      return store.filterOrder
    },
    getFilterTime (store) {
      return store.filterTime
    },
    // campo de busqueda
    getSearchCommerces (store) {
      return store.search
    },
    getIsXLScreen(store) {
      return store.isXLScreen
    },
    getOpenBurguerMenu(store) {
      return store.openBurguerMenu;
    }
  },
  actions: {
  },
  modules: {
    auth,
    user,
    university,
    countries,
    city,
    cart,
    orders,
    evaluationOrder,
    checkout,
    subscriptions
  },
  // @ts-ignore
  plugins: [createPersistedState({
    key: '_tc'
  })]
})

export default store
